const autoNgTemplateLoaderTemplate1 = require('./revenue-report.template.html');

'use strict';

import { SOLUTION_TYPE } from '../../modules/shared/constants/user-info/solutionType';

(function () {
    angular
        .module('app.revenueReport', [])
        .config(revenueReportConfig);

    revenueReportConfig.$inject = ['$routeProvider'];

    function revenueReportConfig($routeProvider) {
        $routeProvider
            .when('/revenue-report', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'RevenueReportController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.NUTRITION,
                }
            })
    }
})();
